import { InnerBox } from "@/components/elements/InnerBox";
import { Box, Grid, Link, Typography } from "@mui/material";
import { FC, useMemo } from "react";
import { USER_ACTIVE_STATUS, USER_TYPE } from "@/types/enum";
import { TLearnerForm } from "@/features/learner/types/learnerForm";
import { ItemInfo } from "@/components/commons/ItemInfo";
import { getLearnerAccountStatusLabel } from "@/features/learner/utils/getLabels";
import { divider, orange, state } from "@/theme/colors";
import { findLabelByValue } from "@/utils/object";
import { useEnum } from "@/api/services/global/enum";
import { useInitSetup } from "@/providers/InitSetupProvider";

type TLearnerStatusDetailProps = {
  data?: Partial<TLearnerForm>;
};

export const LearnerStatusDetail: FC<TLearnerStatusDetailProps> = ({ data }) => {
  const { userType } = useInitSetup();
  const isSupportUser = userType === USER_TYPE.SUPPORT_USER;
  const { data: planStatusOptions } = useEnum("EPlanStatus");
  const hasAccount = useMemo(
    () => !!data?.isArchive || !!(data?.userId && data?.user && !data?.user?.isArchive && data?.user?.activeStatus === USER_ACTIVE_STATUS.ACTIVE),
    [data],
  );

  const scrollToAccountSection = () => {
    const element = document.getElementById("learner-account-section");
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const accountStatusLabel = getLearnerAccountStatusLabel(data?.userId, data?.user?.activeStatus, data?.isArchive, data?.user?.isArchive);

  return (
    <>
      {!isSupportUser && !hasAccount && !!data?.industry?.subjects?.length && data?.isUsingLearningApp !== false && (
        <Box bgcolor={state.incomplete_secondary} border={`1px solid ${divider.high}`} borderRadius={1} p={2} mb={4}>
          <Typography variant="head20Bold" color={orange[80]}>
            次のステップ
          </Typography>
          <Link
            component="p"
            variant="body14"
            onClick={scrollToAccountSection}
            color={state.link_1}
            sx={{ cursor: "pointer", letterSpacing: 0 }}
            mt={3}
          >
            学習者情報は登録済みですがアカウント発行前です。こちらからアカウントを発行し、学習者にURLとパスワードを共有してください。
          </Link>
        </Box>
      )}
      <InnerBox
        title={<Typography variant="head20Bold">ステータス</Typography>}
        showDivider={false}
      >
        <Grid container rowSpacing={2} columnSpacing={3} mt={1}>
          <Grid item xs={6}>
            <ItemInfo
              label="受験ステータス"
              value={data?.learnerPlan?.planStatus ? findLabelByValue(planStatusOptions, data.learnerPlan.planStatus) : ""}
              isShowDivider={false}
            />
          </Grid>
          <Grid item xs={6}>
            <ItemInfo label="学習者アカウント" value={accountStatusLabel} isShowDivider={false} />
          </Grid>
        </Grid>
      </InnerBox>
    </>
  );
};
